// extracted by mini-css-extract-plugin
module.exports = {"descriptions":"LrvDescriptions_descriptions__35wjG","lightDescriptions":"LrvDescriptions_lightDescriptions__3hHwC","darkDescriptions":"LrvDescriptions_darkDescriptions__gCjZD"};